<template>
  <div class="minwidth w100 mw100" style="background-color: #0E2038;">
    <tabbar></tabbar>

    <div>
      <div class="positionrel w100">
        <img :src="require('../../public/img/join/bg5.png')" class="positionabs" />
        <div style="color: #fff;font-size: 3rem;position: absolute;top: 6rem;left: 50%;transform: translate(-50%);width: 50%;text-align: center;">
          信息服务优势
          <div
            style="text-align: center;color: #fff;cursor: pointer;width: 100%;margin: 0 auto;height: 2rem;line-height: 2rem;border-radius: 2rem;font-size: 1.2rem;margin-top: 1rem;">获取运营策划解决方案会员优惠价：3000元起在线预约方案
          </div>
          <div
            style="text-align: center;color: #fff;cursor: pointer;background-color: #06D1ED;width: 30%;margin: 0 auto;height: 2rem;line-height: 2rem;border-radius: 2rem;font-size: 0.8rem;margin-top: 1rem;"
            @click="gotoLogin">获取信息服务</div>
        </div>
      </div>

      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            01
          </div>
          <div>
            <div style="font-size: 1.2rem;">卓越的信息采集与实时数据处理能力</div>
            <div style="font-size: 1rem;">DATA PROCESSING CAPABILITY</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 35%;">
            <img style="width: 100%;" :src="require('../../public/img/trends/block1.png')" alt="">
          </div>
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;text-indent: 2em;">
            我们的平台具备业界领先的信息采集能力，能够实时精准地捕捉各类设备、传感器及环境数据。借助高速网络与先进的传输技术，确保数据的快速上传与传输，提供高效、实时的全局视图。同时，我们结合大数据技术和强大的数据处理引擎，能够在海量信息中迅速筛选出关键数据，为企业决策提供可靠依据。平台支持自动化的信息发布功能，实时将关键信息传递给相关人员与系统，确保信息及时流通。
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            02
          </div>
          <div>
            <div style="font-size: 1.2rem;">精准的数据分析与智能决策支持</div>
            <div style="font-size: 1rem;">DATA ANALYSIS & DECISION SUPPORT</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;text-indent: 2em;">
            依托强大的数据分析平台，我们提供深度的数据挖掘与智能分析功能。通过运用人工智能和机器学习算法，精准解读数据背后的商业价值，预测未来趋势与潜在风险，为企业的战略决策提供数据支持。我们的平台不仅能提供决策支持，还支持多渠道的信息发布，确保分析结果快速而高效地传递到各个业务部门，帮助企业快速响应市场变化。
          </div>
          <div style="width: 35%;">
            <img style="width: 100%;" :src="require('../../public/img/trends/block2.png')" alt="">
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            03
          </div>
          <div>
            <div style="font-size: 1.2rem;">全面的信息整合与智能化优化</div>
            <div style="font-size: 1rem;">INFORMATION INTEGRATION & INTELLIGENT OPTIMIZATION</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 35%;">
            <img style="width: 100%;" :src="require('../../public/img/trends/block3.png')" alt="">
          </div>
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;text-indent: 2em;">
            我们将各类异构信息源整合到统一的平台中，实现跨系统、跨平台的数据流通与无缝连接。这不仅突破了设备与系统之间的信息孤岛，也让企业能够在一个统一的平台上对多维度信息进行全面管理。基于综合信息的全面分析，我们提供智能化优化建议，并通过信息发布功能将优化方案及时传递至企业运营团队，从而实现业务的自动化与精细化管理。
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            04
          </div>
          <div>
            <div style="font-size: 1.2rem;">精准的用户画像与个性化服务推荐</div>
            <div style="font-size: 1rem;">USER PROTRAIT & SERVICE RECOMMENDATION</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;text-indent: 2em;">
            通过实时收集用户行为数据与环境数据，我们为每一位用户建立全面的数字化画像，深刻理解用户需求与偏好。基于数据驱动的智能算法，我们可以为用户提供个性化的服务推荐。通过信息发布功能，将个性化推荐和服务信息准确推送到用户端，提升用户体验与品牌忠诚度，并可根据用户反馈即时调整推荐内容。
          </div>
          <div style="width: 35%;">
            <img style="width: 100%;" :src="require('../../public/img/trends/block4.png')" alt="">
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            05
          </div>
          <div>
            <div style="font-size: 1.2rem;">强大的信息安全保障与隐私保护能力</div>
            <div style="font-size: 1rem;">SECURITY GUARANTEE</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 35%;">
            <img style="width: 100%;" :src="require('../../public/img/trends/block5.png')" alt="">
          </div>
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;text-indent: 2em;">
            信息安全是服务的核心基础。我们采用业内先进的信息安全技术，提供全方位的信息安全保护，包括端到端加密、身份验证、动态权限控制等多重安全手段，确保数据的安全性和隐私性。同时，平台支持通过安全认证机制发布信息，确保信息传递过程中的安全性与合规性。平台会定期进行安全漏洞扫描与风险评估，确保每一环节的安全无虞，为用户数据隐私提供严格的保障。
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            06
          </div>
          <div>
            <div style="font-size: 1.2rem;">实时监控推广信息反馈</div>
            <div style="font-size: 1rem;">INFORMATION FEEDBACK</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;text-indent: 2em;">
            我们的平台不仅能实时获取并处理海量数据，还能够即时将关键信息反馈给企业管理层。无论是设备状态、生产进度，还是市场变化、用户反馈，我们都能通过实时监控与自动化报告功能，帮助企业快速做出响应。我们支持智能化的信息发布机制，将关键信息实时推送至相关人员或系统，确保每一个决策都能基于信息流反馈的实时信息，及时调整业务策略。
          </div>
          <div style="width: 35%;">
            <img style="width: 100%;" :src="require('../../public/img/trends/block6.png')" alt="">
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            07
          </div>
          <div>
            <div style="font-size: 1.2rem;">信息服务能力驱动企业数字化转型</div>
            <div style="font-size: 1rem;">DIGITAL TRANSFORMATION</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 35%;">
            <img style="width: 100%;" :src="require('../../public/img/trends/block2.png')" alt="">
          </div>
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;text-indent: 2em;">
            我们通过整合先进的技术，如云计算、大数据分析与人工智能等，为企业提供全方位的信息服务支持，推动企业实现数字化转型。无论是在生产管理、物流调度还是客户关系管理中，我们都能提供准确、高效的信息流动与决策支持。通过灵活的信息发布功能，我们帮助企业快速传播关键信息，提升市场响应速度、优化资源配置，成为行业的数字化引领者。以上调整突出了平台的信息发布能力，确保信息流的快速传播与高效管理，并且加强了对企业的全方位支持。
          </div>
        </div>
      </div>
    </div>

    <bottom></bottom>

    <!-- <customerservice></customerservice> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },

    methods: {
      routerPush(num) {
        this.$router.push({ path: '/trendsNum', query: { id: num } })
      },
      gotoJoin() {
        this.$router.push({ path: '/join' })
      },
      gotoLogin() {
        this.$router.push({ path: '/login' })
      }
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .w100 {
    width: 100%;
  }

  .w90 {
    width: 90%;
  }

  .w60 {
    width: 60%;
  }

  .w30 {
    width: 30%;
  }

  .w200 {
    width: 200px;
  }

  .minwidth {
    min-width: 1000px;
  }

  .flex {
    display: flex;
  }

  .textcent {
    text-align: center;
  }

  .fontsize50 {
    font-size: 50px;
  }

  .fontsize20 {
    font-size: 20px;
  }

  .fontsize14 {
    font-size: 14px;
  }

  .fontsize12 {
    font-size: 12px;
  }

  .fontcolorb0 {
    color: #b0b0b0;
  }

  .margincent {
    margin: 0 auto;
  }

  .margincentY {
    margin: auto 0;
  }

  .margintop20 {
    margin-top: 20px;
  }

  .margintop50 {
    margin-top: 50px;
  }

  .margintop70 {
    margin-top: 70px;
  }

  .marginleft20 {
    margin-left: 20px;
  }

  .marginbot40 {
    margin-bottom: 40px;
  }

  .paddingtop20 {
    padding-top: 20px;
  }

  .title {
    color: #000
  }

  .title:hover {
    color: #bc9158;
  }

  .positionrel {
    position: relative;

    height: 320px;
    overflow: hidden;
  }

  .positionabs {
    position: absolute;
    left: 50%;
    transform: translate(-50%);

    width: 1920px;
    -webkit-filter: contrast(50%);
    filter: contrast(50%);
  }

  .textAlign_justify {
    text-align: justify;
  }

  .whitespace {
    white-space: pre-wrap;
    line-height: 30px;
  }

  @media screen and (max-width: 750px) {
    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }

    .flexnone {
      display: block;
    }

    .w80 {
      width: 80%;
    }

    .w300 {
      width: 300px;
    }

    .fontsize30 {
      font-size: 30px;
    }

    .marginleft20 {
      margin-left: 0;
    }

    .title {
      color: #bc9158;
    }

    .positionrel {
      position: relative;

      height: 179px;
      overflow: hidden;
    }

    .positionabs {
      position: absolute;
      left: 50%;
      transform: translate(-50%);

      width: 780px;
    }
  }
</style>